import { ActionDefinition, AutomationRecordType, NodeKey } from "@/components/automations/types"

import { ActionCatalog } from "../constants"
import { aiActions } from "./ai"
import { businessActions } from "./business"
import { contactActions } from "./contact"
import { flowActions } from "./flow"
import { householdActions } from "./household"
import { meetingActions } from "./meeting"
import { opportunityActions } from "./opportunity"
import { projectActions } from "./project"
import { systemActions } from "./system"
import { taskActions } from "./task"

/**
 * All available action definitions grouped by record type
 */
export const ACTION_DEFINITIONS: Record<AutomationRecordType, ActionDefinition[]> = {
  contact: contactActions,
  business: businessActions,
  household: householdActions,
  task: taskActions,
  meeting: meetingActions,
  opportunity: opportunityActions,
  person: [],
  project: projectActions,
}

/**
 * Get action definition by key
 */
export function getActionDefinition(key?: NodeKey): ActionDefinition | undefined {
  if (!key) return undefined

  for (const actions of Object.values(ACTION_DEFINITIONS)) {
    const action = actions.find((a) => a.key === key)
    if (action) return action
  }

  const aiAction = aiActions.find((a) => a.key === key)
  if (aiAction) return aiAction

  const flowAction = flowActions.find((a) => a.key === key)
  if (flowAction) return flowAction

  const systemAction = systemActions.find((a) => a.key === key)
  if (systemAction) return systemAction

  return undefined
}

/**
 * Get the full action catalog with all available actions.
 * Actions are enabled/disabled based on requiresSubjects, not filtered by record type.
 */
export function getActionCatalog(): ActionCatalog {
  return {
    contact: contactActions,
    business: businessActions,
    household: householdActions,
    task: taskActions,
    opportunity: opportunityActions,
    project: projectActions,
    ai: aiActions,
    flow: flowActions,
    system: systemActions,
  }
}
